import { Container, Grid, Typography } from "@mui/material";
import React from "react";

export default function About() {
  return (
    <>
      <Container maxWidth="md">
        <Grid
          container
          style={{
            backgroundColor: "#fff",
            alignItems: "center",
            justifyContent: "center",
          }}
          justify="center"
        >
          <Grid item xs={12} style={{ margin: "2vh" }}>
            <Typography
              variant="h3"
              component="div"
              style={{
                fontFamily: "Montserrat",
                fontWeight: "600",
                fontDisplay: "swap",
              }}
            >
              OM OSS
            </Typography>
            <Typography
              component="div"
              style={{
                fontFamily: "Montserrat",
                fontWeight: "400",
                fontDisplay: "swap",
              }}
            >
              <p>
                Vi är själva arbetande i hantverksbranschen och har kämpat i
                många år för att hitta den rätta balansen – antingen har vi för
                mycket eller för lite jobb. Vi ville hitta ett lättare sätt att
                få en lagom arbetsbelastning och därmed spara tid och pengar.
              </p>
              <p>
                Vi har utvecklat JoJoo för att lösa detta problem. JoJoo är en
                medlemsplattform där man lätt kan hitta hjälp av andra företag i
                branschen
              </p>
              <p>
                Behöver ni hjälp? Lägg in annons och välj själv rätt företag som
                kan hjälpa er snabbt och enkelt.
              </p>
              <p>
                Behöver ni mer jobb? Hitta annonser från andra företag i ditt
                område som är i behov av hjälp.
              </p>
              <p>
                JoJoo är ett modernt verktyg som maximerar er lönsamhet, testa
                själv!
              </p>
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
